// 图片过滤，获取原图
export var suffix = function (imgurl) {
    if (imgurl && imgurl.includes('images.location.pub') && !imgurl.includes('-location_')) {
        imgurl += '-location_original';
    }
    return imgurl;
};
// location的展位图片 图片过滤，获取 180* 180
export var linhuibaHalf = function (imgurl) {
    if (imgurl && imgurl.includes('img.linhuiba.com')) {
        imgurl += '-location_half?v=1';
    }
    return imgurl;
};
